import { render, staticRenderFns } from "./TalleresCalidadPremium.vue?vue&type=template&id=31856a34&scoped=true&"
import script from "./TalleresCalidadPremium.vue?vue&type=script&lang=js&"
export * from "./TalleresCalidadPremium.vue?vue&type=script&lang=js&"
import style0 from "./TalleresCalidadPremium.vue?vue&type=style&index=0&id=31856a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31856a34",
  null
  
)

export default component.exports